require("dotenv").config();

import Vue from "vue";
import App from "./App.vue";
import Auth from "./services/Auth";
import "./assets/stylesheets/application.scss";
import 'sweetalert2/dist/sweetalert2.min.css';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.config.productionTip = false;

// Disponível em todos os componentes para esconder criar/editar/excluir de
// quem não tem a funcionalidade "<recurso>#new_edit_destroy" no SGU.
Vue.mixin({
  methods: {
    podeEscrever(recurso) {
      return new Auth().podeEscrever(recurso);
    },
  },
});

new Vue({
  render: (h) => h(App),
}).$mount("#app");
